// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { createPortal } from 'react-dom'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import { LoadingIcon } from 'components'

const loaderWrapper = document.getElementById('connected-loader')

const ConnectedLoader = ({ isLoading }) => (
  createPortal(
    <LoadingIcon isLoading={isLoading} />,
    loaderWrapper,
  )
)

ConnectedLoader.propTypes = {
  isLoading: bool.isRequired,
}

const mapStateToProps = ({ loading }) => ({
  isLoading: loading > 0,
})

export default connect(
  mapStateToProps,
)(ConnectedLoader)
